export default {
  'CAD|Yes': 'Yes',
  '3D Rotate': '3D Rotate',
  'API Key': 'API Key',
  'Academic Rank': 'Academic Rank',
  'Academic Rank/Degree': 'Academic Rank/Degree',
  'Account List': 'Account List',
  'Acquisition Time (s)': 'Acquisition Time (s)',
  'Active viewport has no displayed image':
    'Active viewport has no displayed image',
  'Add Account': 'Add Account',
  'Add Device': 'Add Device',
  'Add Filter Condition': 'Add Filter Condition',
  'Add Filter': 'Add Filter',
  'Add Group Account': 'Add Group Account',
  'Add Institution': 'Add Facility',
  'Add Layout Report': 'Add Layout Report',
  'Add Order': 'Add Order',
  'Add Procedure Group': 'Add Procedure Group',
  'Add Procedure': 'Add Procedure',
  'Add Body Part': 'Add Body Part',
  'Add Department': 'Add Department',
  'Add Role': 'Add Role',
  'Add Rule CAD': 'Add Rule CAD',
  'Add Template': 'Add Template',
  'Add User': 'Add User',
  'Adjust Window': 'Adjust Window',
  'All exam for this patient id': 'All exam for this patient id',
  'All files uploading will be canceled.':
    'All files uploading will be canceled.',
  'All time': 'All time',
  'All Time': 'All Time',
  'Approve Date': 'Approve Date',
  'Approved By': 'Approved By',
  'Are you sure you want to close?': 'Are you sure you want to close?',
  'Are you sure you want to delete share?':
    'Are you sure you want to delete share?',
  'Arrived At': 'Arrived At',
  'Assign Radiologist': 'Assign Radiologist',
  'Assign Type': 'Assign Type',
  'Assigned At': 'Assigned At',
  'Assigned List': 'Assigned List',
  'Assigned To': 'Assigned To',
  'File Attachment': 'File Attachment',
  'Auto Send to CAD': 'Auto Send to CAD',
  'Body Part': 'Body Part',
  'CAD Not Supported': 'CAD Not Supported',
  'CAD Suggestion': 'CAD Suggestion',
  'CAD need more time for diagnosing': 'CAD need more time for diagnosing',
  'Can not start camera': 'Can not start camera',
  'Can not stop camera': 'Can not stop camera',
  'Open Camera': 'Open Camera',
  'Capture Image': 'Capture Image',
  'Capture Video': 'Capture Video',
  'Record Video': 'Record Video',
  Fullscreen: 'Fullscreen',
  'Change Device': 'Change Device',
  'Change Password': 'Change Password',
  'Change Value DICOM Fields': 'Change Value DICOM Fields',
  'Choose Report Template': 'Choose Report Template',
  'Clear Filter': 'Clear Filter',
  'Confirm Password': 'Confirm Password',
  'Create Order': 'Create Order',
  'Create RT Report': 'Create RT Report',
  'Create Report': 'Create Report',
  'Create error': 'Create error',
  'Created At': 'Created At',
  'Data List': 'Data List',
  'Demographic Info': 'Demographic Info',
  'Device Name': 'Device Name',
  'Device Type': 'Device Type',
  'Dicom Adapter': 'Dicom Adapter',
  'Dicom Data': 'Dicom Data',
  'Drag and drop files here or': 'Drag and drop files here or',
  'Edit Account': 'Edit Account',
  'Edit Assign Radiologist': 'Edit Assign Radiologist',
  'Edit Device': 'Edit Device',
  'Edit Filter': 'Edit Filter',
  'Edit Group Account': 'Edit Group Account',
  'Edit Institution': 'Edit Facility',
  'Edit Layout Report': 'Edit Layout Report',
  'Edit Order': 'Edit Order',
  'Edit Procedure Group': 'Edit Procedure Group',
  'Edit Procedure': 'Edit Procedure',
  'Edit Report': 'Edit Report',
  'Edit Role': 'Edit Role',
  'Edit Rule CAD': 'Edit Rule CAD',
  'Edit Template': 'Edit Template',
  'Enter AETitle': 'Enter AETitle',
  'Enter API Key': 'Enter API Key',
  'Enter Academic Rank': 'Enter Academic Rank',
  'Enter Academic Rank/Degree': 'Enter Academic Rank/Degree',
  'Enter Address': 'Enter Address',
  'Enter Age': 'Enter Age',
  'Enter Approver Name': 'Enter Approver Name',
  'Enter Birthday': 'Enter Birthday',
  'Enter Body Part': 'Enter Body Part',
  'Enter Conclusion': 'Enter Conclusion',
  'Enter Content': 'Enter Content',
  'Enter Device Name': 'Enter Device Name',
  'Enter Diagnoses': 'Enter Diagnoses',
  'Enter Email': 'Enter Email',
  'Enter Expired Date': 'Enter Expired Date',
  'Enter Filter Name': 'Enter Filter Name',
  'Enter Full Name': 'Enter Full Name',
  'Enter Gender': 'Enter Gender',
  'Enter Group Name': 'Enter Group Name',
  'Enter HIS ID': 'Enter HIS ID',
  'Enter Hostname/IP': 'Enter Hostname/IP',
  'Enter Institution Name': 'Enter Facility Name',
  'Enter Layout Name': 'Enter Layout Name',
  'Enter Order Doctor': 'Enter Order Doctor',
  'Enter Order Group': 'Enter Accession Number',
  'Enter Pass Code': 'Enter Pass Code',
  'Enter Password': 'Enter Password',
  'Enter Patient ID': 'Enter Patient ID',
  'Enter Patient Name': 'Enter Patient Name',
  'Enter Phone Number': 'Enter Phone Number',
  'Enter Procedure Code': 'Enter Procedure Code',
  'Enter Procedure Group Name': 'Enter Procedure Group Name',
  'Enter Procedure Name': 'Enter Procedure Name',
  'Enter Department Code': 'Enter Department Code',
  'Enter Department Name': 'Enter Department Name',
  'Enter Body Part Name': 'Enter Body Part Name',
  'Enter Refer Doctor': 'Enter Refer Doctor',
  'Enter Role Code': 'Enter Role Code',
  'Enter Role Name': 'Enter Role Name',
  'Enter Rule Name': 'Enter Rule Name',
  'Enter Source AETitle': 'Enter Source AETitle',
  'Enter Template Code': 'Enter Template Code',
  'Enter Template Name': 'Enter Template Name',
  'Enter Type': 'Enter Type',
  'Enter Username': 'Enter Username',
  'Enter Visit ID': 'Enter Visit Number',
  'Enter address': 'Enter address',
  'Enter body part': 'Enter body part',
  'Enter confirm password': 'Enter confirm password',
  'Enter description': 'Enter description',
  'Enter device name': 'Enter device name',
  'Enter in the format': 'Enter in the format',
  'Enter institution code': 'Enter facility code',
  'Enter interval': 'Enter interval',
  'Enter password': 'Enter password',
  'Enter port': 'Enter port',
  'Enter procedure code': 'Enter procedure code',
  'Enter short name': 'Enter short name',
  'Enter username': 'Enter username',
  'Error Message': 'Error Message',
  'Exam By Radiologist': 'Exam By Radiologist',
  Exams: 'Exams',
  'Exam Info': 'Exam Info',
  'Expired At': 'Expired At',
  'Expired Date': 'Expired Date',
  'Export CSV': 'Export CSV',
  'FOR INVESTIGATIONAL USE ONLY': 'FOR INVESTIGATIONAL USE ONLY',
  'File Name': 'File Name',
  'File Type': 'File Type',
  'Film Size': 'Film Size',
  'Film Type': 'Film Type',
  'Filter Management': 'Filter Management',
  'Filter Name': 'Filter Name',
  'Filter Type': 'Filter Type',
  'Freehand Scalpel': 'Freehand Scalpel',
  'Full Name': 'Full Name',
  'Generate Key': 'Generate Key',
  'Generate Link': 'Generate Link',
  'Go back Home': 'Go back Home',
  'Group Account List': 'Group Account List',
  'Group Account': 'Group Account',
  'Group Name': 'Group Name',
  'HIS ID': 'HIS ID',
  // 'Half Life (s)': 'Half Life (s)', '',
  'Header:About': 'Header:About',
  'Header:Logout': 'Header:Logout',
  'Header:Preferences': 'Header:Preferences',
  'Hostname/IP': 'Hostname/IP',
  'INVESTIGATIONAL USE ONLY': 'INVESTIGATIONAL USE ONLY',
  'Image height (px)': 'Image height (px)',
  'Image preview': 'Image preview',
  'Image width (px)': 'Image width (px)',
  'Import files': 'Import files',
  'Injection Time (s)': 'Injection Time (s)',
  'Institution Code': 'Facility Code',
  'Institution Name': 'Facility Name',
  'Interval(s)': 'Interval(s)',
  'Invalid image': 'Invalid image',
  'Invalid username': 'Invalid username',
  'Key Image': 'Key Image',
  'Last 30 days': 'Last 30 days',
  'Last Month': 'Last Month',
  'Layout List': 'Layout List',
  'Layout Name': 'Layout Name',
  'Layout Report': 'Layout Report',
  'Loading recent report...': 'Loading recent report...',
  Match: 'Match',
  'Match Order': 'Match Order',
  'Match Status': 'Match Status',
  'Medium Type': 'Medium Type',
  'Merge Order With Same Patient': 'Merge Order With Same Patient',
  'NON-DICOM': 'NON-DICOM',
  'New Report': 'New Report',
  'No Order': 'No Order',
  'No layout selected yet': 'No layout selected yet',
  'No permission found': 'No permission found',
  'No selected order': 'No selected order',
  'No tracked measurements': 'No tracked measurements',
  'No video source': 'No video source',
  'Non-dicom Data': 'Non-dicom Data',
  'Not strong enough': 'Not strong enough',
  'Number Of Copies': 'Number Of Copies',
  'Only Super Admin can add new role': 'Only Super Admin can add new role',
  'Only show failed files': 'Only show failed files',
  'Open Report': 'Open Report',
  'Open Viewer and Report': 'Open Viewer and Report',
  'Open Viewer': 'Open Viewer',
  'Open in Split Window and Report': 'Open in Split Window and Report',
  'Open in Split Window': 'Open in Split Window',
  'Order Date': 'Order Date',
  'Order Doctor': 'Order Doctor',
  'Order Group': 'Accession Number',
  'Order Information': 'Order Information',
  'Order List': 'Order List',
  'Order Search': 'Order Search',
  'Ordinal Number': 'Ordinal Number',
  'Page Number': 'Page Number',
  'Invalid Pass Code': 'Invalid Pass Code',
  'Invalid Citizen ID': 'Invalid Citizen ID',
  'Pass Code Required': 'Pass Code Required',
  'Password does not match': 'Password does not match',
  'Patient ID': 'Patient ID',
  'Patient Info': 'Patient Info',
  'Patient Information': 'Patient Information',
  'Patient Name': 'Patient Name',
  'Patient Search': 'Patient Search',
  'Patient Sex': 'Patient Sex',
  'Patient Weight (kg)': 'Patient Weight (kg)',
  'Patient search': 'Patient search',
  'Percentage of Max SUV': 'Percentage of Max SUV',
  'Performance By Radiologist': 'Performance By Radiologist',
  'Performed Studies': 'Performed Studies',
  'Phone Number': 'Phone Number',
  'Please allow access to your camera and microphone':
    'Please allow access to your camera and microphone',
  'Please enter a number': 'Please enter a number',
  'Please enter a positive number': 'Please enter a positive number',
  'Please enter note': 'Please enter note',
  'Please enter password': 'Please enter password',
  'Print Page Range': 'Print Page Range',
  'Print Type': 'Print Type',
  'Procedure Code': 'Procedure Code',
  'Procedure Group Name': 'Procedure Group Name',
  'Procedure Group': 'Procedure Group',
  'Procedure Name': 'Procedure Name',
  'Procedure Search': 'Procedure Search',
  'Department Code': 'Department Code',
  'Department Name': 'Department Name',
  Department_Title: 'Department',
  'Body Part Name': 'Body Part Name',
  'Processing...': 'Processing...',
  // 'ROI Threshold Configuration': 'ROI Threshold Configuration', '',
  'Rectangle Scalpel': 'Rectangle Scalpel',
  'Refer Doctor': 'Refer Doctor',
  'Reject latest report': 'Reject latest report',
  'Remove Bed': 'Remove Bed',
  'Report History': 'Report History',
  'Report Template': 'Report Template',
  'Required value': 'Required value',
  'Reset password': 'Reset password',
  'Reset to Defaults': 'Reset to Defaults',
  'Role Code': 'Role Code',
  'Role Name': 'Role Name',
  'Rule CAD': 'Rule CAD',
  'Rule Name': 'Rule Name',
  'Scheduled Date': 'Scheduled Date',
  'Select Academic Rank': 'Select Academic Rank',
  'Select Account': 'Select Account',
  'Select Auto Send to CAD': 'Select Auto Send to CAD',
  'Select CAD Tool': 'Select CAD Tool',
  'Select Creator': 'Select Creator',
  'Select Date': 'Select Date',
  'Select Device Type': 'Select Device Type',
  'Select Device': 'Select Device',
  'Select Files': 'Select Files',
  'Select Folder': 'Select Folder',
  'Select Gender': 'Select Gender',
  'Select Group Account': 'Select Group Account',
  'Select Institution': 'Select Facility',
  'Select Institutions': 'Select Facilities',
  'Select Layout List': 'Select Layout List',
  'Select Match status': 'Select Match status',
  'Select Modality': 'Select Modality',
  'Select Order status': 'Select Order status',
  'Select Procedure Group': 'Select Procedure Group',
  'Select Procedure Name': 'Select Procedure Name',
  'Select Role': 'Select Role',
  'Select Roles': 'Select Roles',
  'Select Share By': 'Select Share By',
  'Select Share Type': 'Select Share Type',
  'Select Status': 'Select Status',
  'Select Studylist status': 'Select Studylist status',
  'Select Type': 'Select Type',
  'Select condition': 'Select condition',
  'Select date range': 'Select date range',
  'Select date': 'Select date',
  'Select group': 'Select group',
  'Select institutions': 'Select facilities',
  'Select Layout': 'Select Layout',
  'Select technician': 'Select technician',
  'Select type': 'Select type',
  'Selected study only': 'Selected study only',
  'Share By': 'Share By',
  'Share Link': 'Share Link',
  'Share Settings': 'Share Settings',
  'Share Study': 'Share Study',
  'Share Type': 'Share Type',
  'Shared Date': 'Shared Date',
  'Shared List': 'Shared List',
  'Short Name': 'Short Name',
  'Show Annotations': 'Show Annotations',
  'Some files are not supported. Do you want to continue?':
    'Some files are not supported. Do you want to continue?',
  'Split Window': 'Split Window',
  'Split Windows': 'Split Windows',
  'Study Date': 'Study Date',
  'Study Description': 'Study Description',
  'Study Information': 'Study Information',
  'Study Share': 'Study Share',
  'Submitted By': 'Submitted By',
  'Template Code': 'Template Code',
  'Template Name': 'Template Name',
  'Template Report': 'Template Report',
  'Text Size': 'Text Size',
  'This Month': 'This Month',
  Yesterday: 'Yesterday',
  'Last 7 days': 'Last 7 days',
  'This Year': 'This Year',
  'Last Year': 'Last Year',
  'This template will overwrite your current work?':
    'This template will overwrite your current work?',
  // 'Total Dose (bq)': 'Total Dose (bq)', '',
  'Unavailable CAD': 'Unavailable CAD',
  'Update AI result': 'Update AI result',
  'Update Profile': 'Update Profile',
  'Updated At': 'Updated At',
  'Upload Logo': 'Upload Logo',
  'Upload Signature': 'Upload Signature',
  'Upload file success': 'Upload file success',
  'Upload files': 'Upload files',
  'Upload image failed': 'Upload image failed',
  'User List': 'User List',
  'User Settings': 'User Settings',
  'UserPreferencesModal:User Preferences':
    'UserPreferencesModal:User Preferences',
  'Username must be at least 4 characters':
    'Username must be at least 4 characters',
  'Username must be less than 50 characters':
    'Username must be less than 50 characters',
  'Username or Email': 'Username or Email',
  'Visit ID mismatch': 'Visit Number mismatch',
  'Visit ID': 'Visit Number',
  'You need to match study with order or create new order':
    'You need to match study with order or create new order',
  // 'Đăng ký gói MAX': 'Đăng ký gói MAX', '',
  AETitle: 'AETitle',
  APPROVED: 'APPROVED',
  ARRIVED: 'ARRIVED',
  Abnormal: 'Abnormal',
  Access: 'Access',
  Account: 'Account',
  Action: 'Action',
  Actions: 'Actions',
  Active: 'Active',
  Add: 'Add',
  Address: 'Address',
  Administration: 'Administration',
  Age: 'Age',
  All: 'All',
  Apply: 'Apply',
  Approve: 'Approve',
  Approved: 'Approved',
  Approver: 'Approver',
  Arrived: 'Arrived',
  Assign: 'Assign',
  Assigned: 'Assigned',
  Back: 'Back',
  Birthday: 'Birthday',
  Bookmark: 'Bookmark',
  Border: 'Border',
  CAD: 'CAD',
  CANCEL: 'CANCEL',
  COMPLETED: 'COMPLETED',
  Camera: 'Camera',
  Cancel: 'Cancel',
  Capture: 'Capture',
  Clear: 'Clear',
  ClearFilters: 'ClearFilters',
  Close: 'Close',
  Column: 'Column',
  Completed: 'Completed',
  Conclusion: 'Conclusion',
  Condition: 'Condition',
  Confirm: 'Confirm',
  Connection: 'Connection',
  Content: 'Content',
  Creator: 'Creator',
  Crosshairs: 'Crosshairs',
  Custom: 'Custom',
  DICOM: 'DICOM',
  Dashboard: 'Dashboard',
  Delete: 'Delete',
  Description: 'Description',
  // 'Destination': 'Destination',
  Device: 'Device',
  Devices: 'Devices',
  Diagnoses: 'Diagnoses',
  Diagnostic: 'Diagnostic',
  Download: 'Download',
  Edit: 'Edit',
  Email: 'Email',
  Empty: 'Empty',
  End: 'End',
  Export: 'Export',
  Female: 'Female',
  Finish: 'Finish',
  Forbidden: 'Forbidden',
  Function: 'Function',
  Gender: 'Gender',
  General: 'General',
  Group: 'Group',
  Help: 'Help',
  High: 'High',
  Hotkeys: 'Hotkeys',
  Import: 'Import',
  Inactive: 'Inactive',
  Information: 'Information',
  Institution: 'Facility',
  Institutions: 'Facilities',
  Keyword: 'Keyword',
  LOAD: 'LOAD',
  LOGIN: 'LOGIN',
  Language: 'Language',
  Length: 'Length',
  Loading: 'Loading',
  Login: 'Login',
  Logout: 'Logout',
  MRN: 'MRN',
  Magnification: 'Magnification',
  Male: 'Male',
  Matched: 'Matched',
  Max: 'Max',
  Microphone: 'Microphone',
  Min: 'Min',
  Modality: 'Modality',
  NEW: 'NEW',
  New: 'New',
  Next: 'Next',
  No: 'No',
  Normal: 'Normal',
  Note: 'Note',
  // NumOfStudiesHiggerThan100Message: '',
  OK: 'OK',
  Open: 'Open',
  Order: 'Order',
  Orders: 'Orders',
  Orientation: 'Orientation',
  Other: 'Other',
  Overview: 'Overview',
  Page: 'Page',
  Paper: 'Paper',
  Password: 'Password',
  Patient: 'Patient',
  Pending: 'Pending',
  Permissions: 'Permissions',
  Phone: 'Phone',
  Port: 'Port',
  Preferences: 'Preferences',
  Preview: 'Preview',
  Previous: 'Previous',
  Print: 'Print',
  Priority: 'Priority',
  Private: 'Private',
  Procedure: 'Procedure',
  Processed: 'Processed',
  Profile: 'Profile',
  Public: 'Public',
  Quality: 'Quality',
  Quantity: 'Quantity',
  READING: 'READING',
  Reading: 'Reading',
  Receive: 'Receive',
  Reception: 'Reception',
  Report: 'Report',
  Reset: 'Reset',
  Resolution: 'Resolution',
  // ResultsPerPage: '',
  Retry: 'Retry',
  Role: 'Role',
  Roles: 'Roles',
  Save: 'Save',
  Saving: 'Saving',
  Scanner: 'Scanner',
  Search: 'Search',
  // Segmentations: '',
  Select: 'Select',
  Settings: 'Settings',
  Sex: 'Sex',
  Share: 'Share',
  ShareSettings: 'ShareSettings',
  Shortcut: 'Shortcut',
  Signature: 'Signature',
  Sorry: 'Sorry',
  Spacing: 'Spacing',
  Start: 'Start',
  Status: 'Status',
  // Strategy: '',
  Studies: 'Studies',
  StudyList: 'StudyList',
  Studylist: 'Studylist',
  Submit: 'Submit',
  Technician: 'Technician',
  // Thickness: '',
  Today: 'Today',
  Total: 'Total',
  Trim: 'Trim',
  Type: 'Type',
  Unmatched: 'Unmatched',
  Upload: 'Upload',
  User: 'User',
  Username: 'Username',
  Value: 'Value',
  Warning: 'Warning',
  Worklist: 'Worklist',
  Yes: 'Yes',
  browse: 'browse',
  columns: 'columns',
  failed: 'failed',
  items: 'items',
  more: 'more',
  success: 'success',
  to: 'to',
  Expand: 'Expand',
  Collapse: 'Collapse',
  'No Data': 'No Data',
  NO: 'NO',
  Sharing: 'Sharing',
  Shared: 'Shared',
  Expired: 'Expired',
  'Source AETitle': 'Source AETitle',
  'Studylist Status': 'Studylist Status',
  'Order Status': 'Order Status',
  'All devices': 'All devices',
  Unknown: 'Unknown',
  Default: 'Default',
  'My Templates': 'My Templates',
  Guest: 'Guest',
  'Invalid phone number': 'Invalid phone number',
  'At least 10 numbers': 'At least 10 numbers',
  'Please fill in number': 'Please fill in number',
  Layout: 'Layout',
  Study: 'Study',
  Template: 'Template',
  Viewer: 'Viewer',
  'Are you sure to delete dicom study?': 'Are you sure to delete dicom study?',
  'Are you sure delete this annotation?':
    'Are you sure delete this annotation?',
  'Are you sure delete all annotations on this instance?':
    'Are you sure delete all annotations on this instance?',
  "You don't have permission to access this page.":
    "You don't have permission to access this page.",
  'Upload Files': 'Upload Files',
  'file(s)': 'file(s)',

  "It's time to upgrade": "It's time to upgrade",
  'You have reached the limit of your current plan':
    'You have reached the limit of your current plan',
  '10 links per month': '10 links per month',
  'Please register MAX package to continue using this feature':
    'Please register MAX package to continue using this feature',
  'Thank you!': 'Thank you!',
  'Register now': 'Register now',
  'Dashboard Order': 'Dashboard Order',
  'Order By Modality': 'Order By Modality',
  'Top 5 Of Approver': 'Top 5 Of Approver',
  'Top 5 Of Procedure': 'Top 5 Of Procedure',
  'Close Camera': 'Close Camera',
  'HIS Order List': 'HIS Order List',
  'Enter PID': 'Enter PID',
  'Patient Visit List': 'Patient Visit List',
  'Add HIS Order': 'Add HIS Order',
  PID: 'PID',
  Department: 'Department',
  'Procedure Date': 'Procedure Date',
  'Enter Procedure Date': 'Enter Procedure Date',
  'Ender Order': 'Ender Order',
  'Enter Note': 'Enter Note',
  'Enter Department': 'Enter Department',
  'Open camera': 'Open camera',

  "Order with accessionNumber {{ accession_number }} already exists. Can't create a new order.":
    "Order with accessionNumber {{ accession_number }} already exists. Can't create a new order.",

  'Are you sure want to close the camera while recording?':
    'Are you sure want to close the camera while recording?',
  'Shutting off the camera while recording will cause you to lose the video you are capturing.':
    'Shutting off the camera while recording will cause you to lose the video you are capturing.',
  'Continue Recording': 'Continue Recording',
  'Select Department': 'Select Department',
  'Select Body Part': 'Select Body Part',
  'No Report': 'No Report',
  'Powered by': 'Powered by',
  'filter-management.Match': 'Match',
  'filter-management.Not Match': 'Not Match',
  "The report isn't ready yet": "The report isn't ready yet!",

  'Reset All Changes': 'Reset All Changes',
  'All unsaved changes will be removed.':
    'All unsaved changes will be removed.',
  'Proceed Anyway': 'Proceed Anyway',
  'Go back': 'Go back',
  'Loading more...': 'Loading more...',
  'Modify Columns': 'Modify Columns',
  'Order Doctor Name': 'Order Doctor Name',
  'Referring Physician': 'Referring Physician',
  'Study Status': 'Study Status',
  Name: 'Name',
  'Find by Patient ID': 'Find by Patient ID',
  'Pull to refresh': 'Pull to refresh',
  MATCH: 'MATCH',
  UNMATCH: 'UNMATCH',
  'Find by Institution Name': 'Find by Facility Name',
  'From Date': 'From Date',
  'To Date': 'To Date',
  'Access Type': 'Access Type',
};
